import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const options = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: '5+' },
];

interface INumberSelectorProps {
  onChange(value: number): void;
}

const NumberSelector: React.FC<INumberSelectorProps> = ({ onChange }) => {
  const [activeOption, setActiveOption] = useState<number>(0);
  useEffect(() => {
    onChange(activeOption);
  }, [activeOption]);
  return (
    <SelectorContainer>
      {options.map((option) => (
        <button
          key={option.label}
          className={option.value === activeOption ? 'active' : ''}
          onClick={() =>
            setActiveOption(option.value === activeOption ? 0 : option.value)
          }
        >
          {option.label}
        </button>
      ))}
    </SelectorContainer>
  );
};

const SelectorContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(30px, 30px));
  gap: 12px;
  button {
    height: 30px;
    cursor: pointer;
    border: none;
    font-family: ${(props) => props.theme.fonts.helvetica};
    background-color: ${(props) => props.theme.colors.inactiveBackground};
    border-radius: 4px;
    color: #8b8c8f;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    &.active {
      background-color: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.white};
    }
  }
`;

NumberSelector.defaultProps = {
  onChange: () => null,
};

export default React.memo(NumberSelector);
